import { render, staticRenderFns } from "./AddEditBuilding.vue?vue&type=template&id=f3bb9004&"
import script from "./AddEditBuilding.vue?vue&type=script&lang=js&"
export * from "./AddEditBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports